var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29155_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99068 12.1486C3.3382 11.5611 2.8675 10.8567 2.55911 10.1003C1.74106 8.09414 2.12411 5.70818 3.72125 4.06235L5.19502 5.53613C5.27618 5.61728 5.42226 5.55885 5.44174 5.43874L6.2468 0.170148C6.25978 0.0825007 6.18512 0.00783796 6.09747 0.0208228L0.825631 0.825882C0.705522 0.845359 0.64709 0.991439 0.728245 1.07259L2.20527 2.54962C-0.232632 5.0427 -0.648147 8.78233 0.952233 11.7039C1.43267 12.5836 2.09814 13.3887 2.9454 14.0639C4.38672 15.2098 6.15915 15.7584 7.91859 15.7227L8.24971 13.5575C6.73373 13.6874 5.17555 13.2199 3.99068 12.1486ZM13.7942 13.4504C16.2321 10.9573 16.6476 7.21766 15.0473 4.29608C14.5668 3.41635 13.9014 2.6113 13.0541 1.93608C11.6128 0.790174 9.84035 0.241565 8.0809 0.277273L7.74979 2.44249C9.26252 2.31264 10.8239 2.7801 12.0088 3.85135C12.6613 4.43891 13.132 5.14334 13.4404 5.8997C14.2584 7.90586 13.8754 10.2918 12.2782 11.9376L10.8045 10.4639C10.7233 10.3827 10.5772 10.4411 10.5578 10.5613L9.7527 15.8298C9.73971 15.9175 9.81438 15.9922 9.90202 15.9792L15.1739 15.1741C15.294 15.1546 15.3492 15.0086 15.2712 14.9274L13.7942 13.4504Z",
    fill: "#E9F7FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29155_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3078b95272b91433f821d0d9a8536203.svg";
export { ForwardRef as ReactComponent };